module.exports = __webpack_public_path__ + "static/media/alternative-light.35b48a04.svg";